































































import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'Home'
})
export default class extends Vue {
  todoList: any[] = []

  created() {
    this.getTodoList()
  }

  getTodoList() {
    for (let i = 0; i < 10; i++) {
      this.todoList.push({
        isDone: true,
        content: '待处理事项xxoo ' + i
      })
    }
  }

  handleDeleteShortcut(i: number) {
    console.log(i)
  }
  handleAddTodoItem() {
    console.log(1111)
  }
  handleDeleteTodoItem(i: number) {
    console.log(i)
  }
  get hourText() {
    return new Date().getHours() >= 12 ? '下午' : '上午'
  }
}
